// 报警中心
import Log from "../view/log";
import AlarmDeviceManage from "../view/AlarmManage/AlarmDevice/AlarmDeviceManage";
import AlarmDeviceAdd from "../view/AlarmManage/AlarmDevice/AlarmDeviceAdd";
import AlarmDeviceModify from "../view/AlarmManage/AlarmDevice/AlarmDeviceModify";
import PoliceReceiver from "../view/AlarmManage/PoliceReceiver/PoliceReceiver";
import PoliceReceiverAdd from "../view/AlarmManage/PoliceReceiver/PoliceReceiverAdd";
import PoliceReceiverModify from "../view/AlarmManage/PoliceReceiver/PoliceReceiverModify";
import AlarmLinkage from "../view/AlarmManage/AlarmLinkage/AlarmLinkage";
import AlarmLinkageAdd from "../view/AlarmManage/AlarmLinkage/AlarmLinkageAdd";
import AlarmLinkPlanAdd from "../view/AlarmManage/AlarmLinkage/AlarmLinkPlanAdd";
import AlarmLinkPlanModify from "../view/AlarmManage/AlarmLinkage/AlarmLinkPlanModify";
import AlarmRecord from "../view/AlarmManage/AlarmRecord/AlarmRecord";
import PoliceInsertRecord from "../view/AlarmManage/PoliceInsertRecord/PoliceInsertRecord";
import StatisticsByDate from "../view/AlarmManage/PoliceStatistics/StatisticsByDate";
import StatisticsByDevice from "../view/AlarmManage/PoliceStatistics/StatisticsByDevice";
import StatisticsByPerson from "../view/AlarmManage/PoliceStatistics/StatisticsByPerson";
import AlarmNav from "../view/AlarmManage/AlarmNav";

export default [
  /* 报警中心 */
  {
    path: "/alarm_device_manage",
    name: "alarm-device-manage",
    components: {
      default: AlarmNav,
      a: AlarmDeviceManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/alarm_device_add",
    name: "alarm-device-add",
    components: {
      default: AlarmNav,
      a: AlarmDeviceAdd
    }
  },
  {
    path: "/alarm_device_modify/:id",
    name: "alarm-device-modify",
    components: {
      default: AlarmNav,
      a: AlarmDeviceModify
    }
  },
  {
    path: "/police_receiver",
    name: "police-receiver",
    components: {
      default: AlarmNav,
      a: PoliceReceiver
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/police_receiver_add",
    name: "police-receiver-add",
    components: {
      default: AlarmNav,
      a: PoliceReceiverAdd
    }
  },
  {
    path: "/police_receiver_modify/:id",
    name: "police-receiver-modify",
    components: {
      default: AlarmNav,
      a: PoliceReceiverModify
    }
  },
  {
    path: "/alarm_linkage",
    name: "alarm-linkage",
    components: {
      default: AlarmNav,
      a: AlarmLinkage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/alarm_linkage_config/:id",
    name: "alarm-linkage-add",
    components: {
      default: AlarmNav,
      a: AlarmLinkageAdd
    }
  },
  {
    path: "/alarm_linkage_plan_add",
    name: "alarm-linkage-plan-add",
    components: {
      default: AlarmNav,
      a: AlarmLinkPlanAdd
    }
  },
  {
    path: "/alarm_linkage_plan_modify/:id",
    name: "alarm-linkage-plan-modify",
    components: {
      default: AlarmNav,
      a: AlarmLinkPlanModify
    }
  },
  {
    path: "/alarm_record",
    name: "alarm-record",
    components: {
      default: AlarmNav,
      a: AlarmRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/police_insert_record",
    name: "police-insert-record",
    components: {
      default: AlarmNav,
      a: PoliceInsertRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/statistics_by_date",
    name: "statistics-by-date",
    components: {
      default: AlarmNav,
      a: StatisticsByDate
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/statistics_by_device",
    name: "statistics-by-device",
    components: {
      default: AlarmNav,
      a: StatisticsByDevice
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/statistics_by_person",
    name: "statistics-by-person",
    components: {
      default: AlarmNav,
      a: StatisticsByPerson
    },
    meta: {
      keepAlive: true
    }
  },
  // 报警中心操作日志
  {
    path: "/alarm_manage_log",
    name: "alarm-manage-log",
    components: {
      default: AlarmNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/AlarmManage.js